import { css } from '@emotion/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import tw from 'twin.macro';

import Form from '$/components/ui/Form';
import Dropdown from '$/components/ui/Input/Basics/Dropdown';
import Input from '$/components/ui/Input/Basics/Input';
import { PageMode } from '$/components/ui/Input/PageBuilder.types';

import { usePageEditorContext } from '../PageEditorContext';
import { RegFormSettingsForForm } from './types';

const useFullNameFieldOptions = [
  {
    key: '1',
    text: 'Use only Name field',
    description: 'First and last name fields will automatically be parsed out of the name input',
    value: true,
  },
  {
    key: '2',
    text: 'Use First and Last name fields',
    description:
      'Show both a first and last name field.  You can choose whether to make the last name field optional or required.',
    value: false,
  },
];

export const UseFullNameFieldDropdown: React.FC = () => {
  const { mode } = usePageEditorContext();
  const { watch, setValue } = useFormContext<RegFormSettingsForForm>();

  return (
    <>
      <Form.Field name='useFullNameField' type='hidden' component={<Input type='hidden' />} />
      {mode === PageMode.edit && (
        <Dropdown
          basic
          floating
          selection={false}
          fluid={false}
          value={watch('useFullNameField')}
          onChange={(v): void => setValue('useFullNameField', v, { shouldDirty: true })}
          options={useFullNameFieldOptions}
          css={css`
            ${tw`text-blue-3 font-body`}
            margin-bottom: 1.5rem;
            width: 100%;
          `}
        />
      )}
    </>
  );
};
